<!--首页-频道-查看更多 -->
<template>
  <div class="list">
    <van-list
        v-model="loading"
        :finished="finished"
        finished-text="已到底部"
        @load="onLoad"
    >
      <!--课程 -->
      <div class="list-content" v-if="origin_type == 1">
        <div class="subject-list-section" v-for="(item, index) in moreList" :key="index" @click="jump(item)">
          <div class="subject-list-section-box">
            <div class="subject-list-section-left">
              <van-image class="subject-list-section-left-img" fit="cover" :src="item.cover_img" />
              <img v-if="item.type == 2" class="subject-list-section-left-zl" src="/static/v4/icon_list_tag_column.svg" alt="" />
              <img v-else-if="item.live_status == 0" class="subject-list-section-left-zl" src="/static/img/live/icon_list_tag_live_count_down.svg" alt="" />
              <img v-else-if="item.live_status == 1" class="subject-list-section-left-zl" src="/static/img/live/icon_list_tag_live_process.svg" alt="" />
              <img v-else-if="item.live_status == 2" class="subject-list-section-left-zl" src="/static/img/live/icon_list_tag_live_history.svg" alt="" />
            </div>
            <div class="subject-list-section-right">
              <div class="subject-list-section-right-title">{{ item.title }}</div>
              <div class="subject-list-section-right-detail" v-if="item.type == 2">
                共{{ item.total_count }}节  <span style="margin-left: 8px">{{ item.view_count }}人观看</span>
              </div>
              <div class="subject-list-section-right-detail" v-else>
                {{ item.start_at }}
                <span class="subject-list-section-right-detail-join" v-if="item.live_status < 2">
                                              {{ item.live_status === 0 ? (item.isAppointment ? '已预约' : '预约') : '加入' }}
                                          </span>
                <span v-else>{{ item.view_count }}人观看</span>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <!--直播 -->
      <div class="list-content" v-if="origin_type == 4">
        <div class="live-list-section" v-for="(item, index) in moreList" :key="index" @click="jump(item)">
          <div class="live-list-section-box">
            <div class="live-list-section-left">
              <van-image class="live-list-section-left-img" fit="cover" :src="item.cover_img" />
              <img v-if="item.type == 2" class="live-list-section-left-zl" src="/static/two/icon_list_tag_subject_live.svg" alt="" />
              <img v-else-if="item.live_status == 0" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_count_down.svg" alt="" />
              <img v-else-if="item.live_status == 1" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_process.svg" alt="" />
              <img v-else-if="item.live_status == 2" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_history.svg" alt="" />
            </div>
            <div class="live-list-section-right">
              <div class="live-list-section-right-title">{{ item.title }}</div>
              <div class="course-list-section-right-detail" v-if="item.type == 2">已开展{{ item.current_count }}节 | 共{{ item.total_count }}节</div>
              <div class="live-list-section-right-detail" v-else>
                {{ item.start_at }}
                <span class="live-list-section-right-detail-join" v-if="item.live_status < 2">
                                            {{ item.live_status === 0 ? (item.isAppointment ? '已预约' : '预约') : '加入' }}
                                        </span>
                <span v-else>{{ item.view_count }}人观看</span>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <!--病例 -->
      <div class="list-content" v-if="origin_type == 6">
        <div class="case-list-section" v-for="(item, index) in moreList" :key="index" @click="jump(item)">
        <div class="case-list-section-box">
          <div class="case-list-section-left">
            <van-image class="case-list-section-left-img" fit="cover" :src="item.cover_img" />
          </div>
          <div class="case-list-section-right">
            <div class="case-list-section-right-title">{{ item.title }}</div>
            <div class="case-list-section-right-detail" v-if="item.type == 2">
              已开展{{ item.current_count }}节 | 共{{ item.total_count }}节
              <span class="case-list-section-right-detail-join" v-if="item.live_status < 2">
                                            {{ item.live_status === 0 ? '关注' : '已关注' }}
                                        </span>
            </div>
            <div class="case-list-section-right-detail" v-else>
              <span>{{ item.view_count }}人观看</span>
              <span class="case-list-section-right-detail-join" v-if="item.live_status < 2">
                                            {{ item.live_status === 0 ? '关注' : '已关注' }}
                                        </span>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
      </div>
      <!--指南下载 1 pdf 2 图片  3图文-->
      <div class="list-content" v-if="origin_type == 9">
        <div class="download-list-section" v-for="item in moreList" :key="item.id">
          <div class="download-list-section-box">
            <div class="download-list-section-box-left">
              <img v-if="item.type == 3" src="/static/two/download_article.svg" alt="" />
              <img v-else-if="item.type == 1" src="/static/two/download_pdf.svg" alt="" />
              <img v-else src="/static/third/icon_course_download_pic.svg" alt="" style="margin-left: -5px" />
            </div>
            <div class="download-list-section-box-center">
              <div class="download-list-section-box-center-title">
                <span class="download-list-section-title" @click="downloadItem(item)">{{ item.title }}</span>
              </div>
              <div class="download-list-section-box-center-desc">
                                          <span class="download-list-section-box-center-desc-label">
                                              {{ item.created_at }}
                                              <span style="margin-left: 8px" v-if="item.type == 3">{{ item.view_count }}人阅读</span>
                                              <span style="margin-left: 8px" v-else>{{ item.download_count }}人下载</span>
                                              <span style="margin-left: 11px" @click="favorite(item)">
                                                  <img v-if="item.is_favorite" src="/static/two/download_favorite.svg" alt="" />
                                                  <img v-else src="/static/two/download_unfavorite.svg" alt="" />
                                                  <span v-if="item.is_favorite">已收藏</span>
                                                  <span v-else>收藏</span>
                                              </span>
                                          </span>
              </div>
            </div>
            <div class="download-list-section-box-right">
              <img @click="downloadItem(item)" v-if="item.isDownload && item.type_text != '图文'" style="margin-right: 10px" src="/static/two/downloaded.svg" alt="" />
              <img @click="downloadItem(item)" v-else-if="!item.isDownload && item.type_text != '图文'" style="margin-right: 10px" src="/static/two/download.svg" alt="" />
              <div @click="downloadItem(item)" v-else></div>
            </div>
          </div>
        </div>
      </div>
      <!--专栏 -->
      <div class="list-content" v-if="origin_type == 30">
        <div class="column-list-section" v-for="(item, index) in moreList" :key="index" @click="jump(item)">
          <div class="column-list-section-box">
            <div class="column-list-section-left">
              <van-image class="column-list-section-left-img" fit="cover" :src="item.cover_img" />
              <img class="column-list-section-left-zl" src="/static/v4/icon_list_tag_column.svg" alt="" />
            </div>
            <div class="column-list-section-right">
              <div class="column-list-section-right-title">{{ item.title }}</div>
              <div class="column-list-section-right-detail">

                <span>共{{ item.total_count }}篇  <span style="margin-left: 5px">{{ item.view_count }}人观看</span></span>
                <div class="column-list-section-right-detail-join" v-if="item.is_subscribe == 0" @click.stop="attention(item)">
                  <img src="/static/v4/icon_follow.svg" alt="">
                  <span>关注</span>
                </div>
                <div v-else class="column-list-section-right-detail-join" @click.stop="attention(item)">
                  <span>已关注</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--学术会 -->
      <div class="list-content" v-if="origin_type == 31">
        <div class="academic-list-section" v-for="(item, index) in moreList" :key="index" @click="jump(item)">
          <div class="academic-list-section-box">
            <div class="academic-list-section-box-top">
              <img :src="item.cover_img" alt="" />
              <div class="academic-list-section-box-zl1" v-if="item.academic_origin_type == 14">
                <img v-if="item.meeting_status== 0" src="static/v4/icon_list_tag_live_count_down.svg"/>
                <img v-else-if="item.meeting_status== 1" src="static/v4/icon_list_tag_academic_process.svg" />
                <img v-else-if="item.meeting_status== 2" src="static/v4/icon_list_tag_academic_end.svg"/>
              </div>
              <div class="academic-list-section-box-btn" v-if="item.meeting_status == 0">
                <span>报名参会</span>
              </div>
            </div>
            <div class="academic-list-section-box-title">{{ item.title }}</div>
            <div class="academic-list-section-box-time">{{ item.start_at }}</div>
          </div>
        </div>
      </div>
    </van-list>
    <div class="back">
      <img src="/static/v4/btn_back.svg" alt="" @click="$router.go(-1)">
    </div>
  </div>
</template>

<script>
import Interface from "../../util/interface";
export default {
  name: "list",
  data() {
    return {
      moreList: [],
      loading: false,
      finished: false,
      id: '',
      origin_type: '',
      page: 0
    }
  },
  methods: {
    onLoad() {
      this.fetch()
    },
    fetch() {
      this.page++
      let params = {
        origin_type: this.origin_type,
        page: this.page,
        pageSize: 10
      }
      Interface.getData('get', Interface.v4.channel + '/' + this.id, params).then((res) => {
        if (res.code == 0) {
          if (res.data.list && res.data.list.length) {
            this.moreList.push(...res.data.list)
            this.loading = false
            if (this.page >= res.data.total_page) {
              this.finished = true
            }
          }
        }
      })
    },
    jump(item) {
      console.log('item====', item)
      if (item.origin_type == 1) {
        // 课程
        if (item.source_type == 0) {
          // 课程专栏
          this.$router.push({ name: 'course-column', params: { id: item.origin_id} })
        } else if (item.source_type == 4) {
          // 直播专栏
          this.$router.push({ name: 'video-column', params: { id: item.source_id} })
        }
      } else if (item.origin_type == 4) {
        // 直播
        if (item.type === 2) {
          this.$router.push({ name: 'live-column', params: { id: item.origin_id } })
        } else if (item.live_status === 6) {
          this.$router.push({ name: 'live-detail-home', params: { id: item.origin_id } })
        } else {
          if (item.live_status === 0) {
            this.$router.push({ name: 'live-detail', params: { id: item.origin_id } })
          } else {
            this.$router.push({ name: 'live-detail-home', params: { id: item.origin_id } })
          }
        }
      } else if (item.origin_type == 6) {
        // 病例
        const pathUrl = item.type === 1 ? 'article-detail' : 'case-column'
        this.$router.push({ name: pathUrl, params: { id: item.origin_id } })
      } else if (item.origin_type == 9) {
        // 指南下载
      } else if (item.origin_type == 30) {
        // 专题
        this.$router.push({ name: 'medical-column-detail', params: { id: item.origin_id } })
      } else if (item.origin_type == 31) {
        // 学术会
        if (item.academic_origin_type == 4) {
          // 直播
          this.$router.push({name: 'live-detail', params: { id: item.origin_id }})
        } else if (item.academic_origin_type == 14) {
          // 会议
          window.location.href = 'https://conference-h5.dr-gobroad.com/#/r?m=' + item.uuid
        } else if (item.academic_origin_type == 13) {
          this.$router.push({name: 'topic-detail', params: { id: item.origin_id }})
        }
      }
    },
    async downloadItem(item) {
      console.log('item=====', item)
      if (item.type == 1) {
        var u = navigator.userAgent
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        if (isiOS) {
          if (item.filesize < 20480) {
            await this.getDetailDownload(item.origin_id)
            item.download_count += 1
            window.location.href = item.link
            return
          }
        }
        this.showEmailVisible = true
        this.current_item = item
      } else if (item.type == 3) {
        this.$router.push({ name: 'download-detail', params: { id: item.id } })
      } else {
        this.showShareDialog = true
        this.current_item = item
      }
    },
    async getDetailDownload(id){
      await Interface.getData('get', Interface.download.download+'/'+id).then((res) => {
        return res
      })
    },
    favorite(item){
      Interface.getData('get', Interface.download.favorite+item.origin_id
      ).then((res) => {
        if(res.code == 0){
          item.is_favorite = !item.is_favorite
        }
      })
    },
    // 关注/未关注
    attention(item) {
      // is_subscribe 0 未关注  1 已关注
      if (item.is_subscribe == 1) {
        // 取消关注
        this.$dialog
            .confirm({
              title: '提醒',
              message: '确定取消关注吗？',
              confirmButtonText: '确定',
              className: 'dly-dialog'
            })
            .then(() => {
              Interface.getData('get', Interface.v4.attation + '/' + item.origin_id).then(res => {
                if (res.code == 0) {
                  this.$toast.success('取消关注成功')
                  item.is_subscribe = 0
                }
              })
            })
            .catch(() => {
              console.log(1)
            })
      } else {
        // 关注
        Interface.getData('get', Interface.v4.attation + '/' + item.origin_id).then(res => {
          if (res.code == 0) {
            this.$toast.success('关注成功')
            item.is_subscribe = 1
          }
        })
      }
    },
  }
  ,created() {
    this.id = this.$route.params.id
    this.origin_type = this.$route.params.origin_type
    // this.fetch()
  }
}
</script>

<style scoped lang="scss">
  @import "./list.scss";
</style>



// WEBPACK FOOTER //
// src/views/home/list.vue